import React from 'react';
import { useWeb3 } from '../context/Web3Context';

// Shown when the wallet is connected but on the wrong chain.
// The switch happens WITHOUT a page refresh — chainChanged just updates state.
export default function NetworkBanner() {
  const { correctChain, switching, ensureNetwork, isConnected } = useWeb3();

  if (!isConnected || correctChain) return null;

  return (
    <div className="net-banner">
      <span>⚠️</span>
      <span style={{ flex: 1 }}>
        Wrong network detected. Switch to continue.
      </span>
      <button className="btn sm blue" style={{ width: 'auto' }} onClick={ensureNetwork} disabled={switching}>
        {switching ? <span className="spin-inline light" /> : null}
        {switching ? 'Switching…' : 'Switch'}
      </button>
    </div>
  );
}
